import React from "react";
import pstvue from "../../asstes/pstvue.png"

const AuthLeftPanel = () => {
  return (
    <div
      className="hidden lg:block w-2/3 bg-[#04254d] relative"
      style={{
        clipPath: "polygon(0 0, 100% 0, 70% 100%, 0% 100%)",
      
      }}
    >
      <div className="absolute inset-0 flex items-center justify-center px-6 lg:px-20">
        <div className="text-white text-center">
          <img
            src={pstvue}
            alt="PortfolioVue Logo"
            className="mx-auto mb-6 w-48 md:w-56 lg:w-72"
          />
          <p className="text-sm  text-gray-200 md:text-base lg:text-xl xl:text-2xl leading-relaxed font-medium">
            Transforming Education With AI Powered <br />
            Platform for every stakeholder
          </p>
        </div>
      </div>
    </div>
  );
};

export default AuthLeftPanel;
